// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vis-cf-conditionalFormatScaleFlexbox{padding-top:8px;align-items:center}.vis-cf-conditionalFormatScaleFlexbox .ba-common-select__wrapper{margin-left:auto}.vis-cf-conditionalFormatScaleFlexbox .ba-common-select .ba-common-button.is-variant_frame{height:30px;width:160px}\n", ""]);
// Exports
module.exports = exports;
